var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.75V14.75L29 14.75",
    stroke: "#6D31ED",
    strokeWidth: 1.44,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27L29 13.5L23 9L11 9L11 27",
    stroke: "#6D31ED",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28.25V31.25L29 31.25V28.25",
    stroke: "#6D31ED",
    strokeWidth: 1.44,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4221 24V23.898L17.4741 20.442H15.6021V19.68H18.9021V19.782L16.8621 23.232H18.8421V24H15.4221ZM19.6802 24V19.68H20.4962V24H19.6802ZM21.3956 24V19.68H23.2196C23.2616 19.68 23.3176 19.682 23.3876 19.686C23.4596 19.688 23.5236 19.694 23.5796 19.704C23.8376 19.744 24.0486 19.829 24.2126 19.959C24.3786 20.089 24.5006 20.253 24.5786 20.451C24.6566 20.647 24.6956 20.866 24.6956 21.108C24.6956 21.35 24.6556 21.57 24.5756 21.768C24.4976 21.964 24.3756 22.127 24.2096 22.257C24.0456 22.387 23.8356 22.472 23.5796 22.512C23.5236 22.52 23.4596 22.526 23.3876 22.53C23.3156 22.534 23.2596 22.536 23.2196 22.536H22.2116V24H21.3956ZM22.2116 21.774H23.1836C23.2256 21.774 23.2716 21.772 23.3216 21.768C23.3716 21.764 23.4176 21.756 23.4596 21.744C23.5696 21.714 23.6546 21.664 23.7146 21.594C23.7746 21.522 23.8156 21.443 23.8376 21.357C23.8616 21.269 23.8736 21.186 23.8736 21.108C23.8736 21.03 23.8616 20.948 23.8376 20.862C23.8156 20.774 23.7746 20.695 23.7146 20.625C23.6546 20.553 23.5696 20.502 23.4596 20.472C23.4176 20.46 23.3716 20.452 23.3216 20.448C23.2716 20.444 23.2256 20.442 23.1836 20.442H22.2116V21.774Z",
    fill: "#6D31ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipFile);
export default __webpack_public_path__ + "static/media/zip_file.c9f0f54e25d740cc1d38151dbc0c7763.svg";
export { ForwardRef as ReactComponent };